import { useRef, useCallback } from "react";

export default function usePolling() {
  // const ref = useRef(null);

  const startPolling = useCallback((ref, fn, delay) => {
    stopPolling(ref);
    ref.current = setInterval(fn, delay);
  }, []);

  const stopPolling = useCallback((ref) => {
    if (!ref.current) return;
    clearInterval(ref.current);
    ref.current = null;
  }, []);

  return { startPolling, stopPolling };
}
